<div class="a-texteditor">
  <quill-editor
    [placeholder]="label"
    [formControl]="control"
    [sanitize]="true"
    (onFocus)="focusIn(true)"
    (onBlur)="checkSave(); focusIn(false);">
  </quill-editor>
</div>